<template>
  <AppContainer class="store-settings-view">
    <header class="store-settings-view__header">
      <h1 class="store-settings-view__title">Configuración de mi tienda</h1>
      <p class="store-settings-view__subtitle">
        Personalizá cómo se ve tu tienda en la plataforma.
      </p>
    </header>

    <AppRow>
      <AppCol cols="12" md="12">
        <ShippingLabelForm />
      </AppCol>
    </AppRow>
  </AppContainer>
</template>

<script>
import AppContainer from '@/components/UI/AppContainer'
import AppRow from '@/components/UI/AppRow'
import AppCol from '@/components/UI/AppCol'
import AppCard from '@/components/UI/AppCard'
import AppBadge from '@/components/UI/AppBadge'
import ShippingLabelForm from '@/components/delivery/ShippingLabelForm'

export default {
  name: 'StoreSettingsView',
  components: {
    AppContainer,
    AppRow,
    AppCol,
    AppCard,
    AppBadge,
    ShippingLabelForm
  }
}
</script>

<style lang="scss" scoped>
.store-settings-view {
  margin-top: 40px;

  &__header {
    margin-bottom: 24px;
  }

  &__title {
    margin: 0 0 8px;
    font-size: 1.75rem;
    font-weight: 600;
  }

  &__subtitle {
    margin: 0;
    color: #6c757d;
  }

  &__muted {
    color: #6c757d;
    margin: 0;
  }
}

.settings-card {
  &--placeholder .app-card__body {
    min-height: 120px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>